import React from "react";
import { toUpper } from "lodash";
import { Icon, IconName } from "@/shared/ui/Icon";
import { Row } from "@/shared/ui/Blocks";
import { cn } from "@/shared/utils/shadcn";

export interface IconTagProps {
  className?: string;
  label?: string;
  color?: string;
  icon?: IconName;
}

const IconTag: React.FC<IconTagProps> = (props) => {
  const { className, color, icon, label } = props;

  return (
    <Row className={cn("gap-2 items-center", className)}>
      <Icon
        size="sm"
        color="blue"
        icon={icon as IconName}
        className={cn(color, "w-4 h-4")}
      />
      <p className={cn("text-xs font-semibold tracking-[1px]", color)}>
        {toUpper(label)}
      </p>
    </Row>
  );
};

export default IconTag;
